/* Fresca — header: mobile menu polish (labels, focus, origin), cart badge state.
   Open/close itself stays in fresca.js ([data-menu-toggle] toggles body.is-menu). */
(() => {
  'use strict';
  const body = document.body;
  const btn = document.querySelector('[data-menu-toggle]');
  const menu = document.getElementById('FrMenu');
  const header = document.querySelector('[data-header]');

  /* Hide the cart bubble while the cart is empty */
  document.querySelectorAll('.fr-cartbtn__count').forEach((el) => {
    const update = () => el.classList.toggle('is-empty', !(parseInt(el.textContent, 10) > 0));
    update();
    new MutationObserver(update).observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* Announcement bar: pause / play the scrolling messages (touch + keyboard users can't hover) */
  const ann = document.querySelector('[data-announce]');
  const annBtn = ann && ann.querySelector('[data-announce-toggle]');
  if (annBtn) {
    annBtn.addEventListener('click', () => {
      const paused = ann.classList.toggle('is-paused');
      annBtn.setAttribute('aria-pressed', String(paused));
    });
  }

  if (!btn || !menu || !header) return;

  const isOpen = () => body.classList.contains('is-menu');
  const visible = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const close = () => { body.classList.remove('is-menu'); btn.setAttribute('aria-expanded', 'false'); };

  // Grow the menu out of the burger, and start its content just under the header.
  const place = () => {
    const b = btn.getBoundingClientRect();
    const h = header.getBoundingClientRect();
    menu.style.setProperty('--mx', Math.round(b.left + b.width / 2) + 'px');
    menu.style.setProperty('--my', Math.round(b.top + b.height / 2) + 'px');
    menu.style.setProperty('--menu-top', Math.max(0, Math.round(h.bottom)) + 'px');
  };
  btn.addEventListener('pointerdown', place);
  btn.addEventListener('click', place, true);
  place();

  let was = false;
  const sync = () => {
    const open = isOpen();
    if (open === was) return;
    was = open;
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    if (open) {
      const first = menu.querySelector('a');
      setTimeout(() => { if (isOpen() && first) first.focus({ preventScroll: true }); }, 380);
    } else if (menu.contains(document.activeElement)) {
      btn.focus({ preventScroll: true });
    }
  };
  new MutationObserver(sync).observe(body, { attributes: true, attributeFilter: ['class'] });

  // Keep keyboard focus inside the burger + menu while it is open.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !isOpen()) return;
    const items = [btn, ...menu.querySelectorAll('a[href], button')].filter(visible);
    const i = items.indexOf(document.activeElement);
    const next = i < 0 ? 0 : (i + (e.shiftKey ? -1 : 1) + items.length) % items.length;
    e.preventDefault();
    items[next].focus();
  });

  // Cart link inside the menu: fresca.js opens the drawer, we just get the menu out of the way
  // (without unlocking scroll, which the drawer still needs).
  menu.querySelectorAll('[data-cart-open]').forEach((a) => a.addEventListener('click', close));

  // Never leave the overlay open on desktop widths or after a back/forward cache restore.
  const desk = window.matchMedia('(min-width: 990px)');
  const onDesk = () => { if (desk.matches && isOpen()) { close(); body.classList.remove('is-locked'); } };
  desk.addEventListener ? desk.addEventListener('change', onDesk) : desk.addListener(onDesk);
  addEventListener('pageshow', (e) => { if (e.persisted && isOpen()) { close(); body.classList.remove('is-locked'); } });
})();
